export function exportReadingCsv(data, filename = "readings.csv") {
    if (!data || data.length === 0) {
        return;
    }
    const headers = [
        "timestamp",
        "key",
        "value",
        "units",
    ];

    const rows = data.map(item => [
        item.timestamp,
        item.key,
        item.value,
        item.units,
    ]);

    const csvContent = [
        headers.join(","),
        ...rows.map(row => row.join(","))
    ].join("\n");

    downloadCsvFile(csvContent, filename);
}


// Creat a blob object for the csv file download
function downloadCsvFile(csvContent, filename) {
    const blob = new Blob(
        [csvContent],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}